import {
    selectDoc, selectArr,
    event, removeClassAll,
    isVisible, addClass, removeClass, toggleClass, hasClass
} from "../utils/utils";

export class Modal {
    /**
     *
     */
    constructor(props = true) {
        this.init(props);
    }

    /**
     *
     */
    init(props = true) {
        let self = this;
        if(props) {
            this.props();
            this.relocateModals();
            event(document, "keydown", function (event) {
                if (window.currentModal && event.keyCode === 27) {
                    self.closeCurrentModal()
                }
            }, true);
        } else {
            this.props(true);
        }
        this.initModals()
    }

    /**
     * Init Modal class properties
     */
    props(simple = false) {
        this.html = selectDoc('html');
        this.pageContainer = selectDoc('#PageContainer');
        if(!simple) {
            window.showModalCount = 0;
            window.currentModal = null;
        }
    }

    closeCurrentModal() {
        let close = selectDoc('.close-modal', selectDoc(window.currentModal));
        close ? close.click() : ''
    }

    closeModalEvents() {
        let self = this;
        let modal = selectDoc(window.currentModal);
        if (modal) {
            let opener = selectDoc(`[data-m="${modal.id}"]`);
            opener ? opener.setAttribute('aria-expanded', 'false') : '';

            window.currentModal = null;
            removeClass(modal, 'active')
            removeClass(modal, 'show-safari-modal')
            removeClass(self.html, 'noscroll')

            /**
             * Close when click outside modal
             */
            window.showModalCount = 0;
            document.removeEventListener('click', self.checkOutSide)

            /**
             * ADA
             */
            modal.setAttribute("aria-hidden", "true");
            self.pageContainer.setAttribute("aria-hidden", "false");
            self.lastFocus ? self.lastFocus.focus() : '';
        }
    }

    /**
     * Click event outside modal
     * @param e
     */
    checkOutSide(e) {
        let modal = selectDoc(window.currentModal + ' .modal');
        if (modal) {
            if (!modal.contains(e.target) && isVisible(modal)) {
                if (window.showModalCount > 0) {
                    let close = selectDoc('.close-modal', selectDoc(window.currentModal));
                    close ? close.click() : ''
                }
            }
            window.showModalCount++;
        }
    }

    relocateModals() {
        let modals = selectDoc('#site-modals-container');
        selectArr('.modal-container:not(.relocated)', this.pageContainer).map(modal => {
            let newModal = modal.cloneNode(true);
            addClass(newModal, 'relocated');
            modals.appendChild(newModal);
            modal.parentNode.removeChild(modal);
        });
    }

    /**
     * Tooltip modals initialization
     * @returns {Promise<void>}
     */
    initModals() {
        let self = this;

        selectArr('.modal-open:not(.jpgg)').map(open => {
            addClass(open, 'jpgg');
            event(open, 'click', function (e) {
                e.preventDefault()
                e.stopPropagation()

                let modal = selectDoc(`#${open.getAttribute('data-m')}`)
                if (modal) {
                    window.currentModal = `#${open.getAttribute('data-m')}`;
                    addClass(modal, 'active')
                    addClass(modal, 'show-safari-modal')
                    addClass(self.html, 'noscroll')
                    open.setAttribute('aria-expanded', 'true')

                    /**
                     * Close when click outside modal
                     */
                    setTimeout(function () {
                        event(document, 'click', self.checkOutSide);
                    },1000)

                    /**
                     * ADA
                     */
                    self.lastFocus = document.activeElement;
                    modal.setAttribute("aria-hidden", "false");
                    self.pageContainer.setAttribute("aria-hidden", "true");
                    selectDoc(window.currentModal) ? selectDoc(window.currentModal).focus() : '';

                    /**
                     * Close event just once
                     */
                    let close = selectDoc('.close-modal', selectDoc(window.currentModal));
                    if (!hasClass(close, 'evented')) {
                        addClass(close, 'evented')
                        event(close, 'click', function (e) {
                            e.preventDefault()
                            self.closeModalEvents();
                        })
                    }
                }
            })
        });
    }
}
